export enum ResourceViewType {
  Grid = "grid",
  Table = "table",
}
